import { render } from "./SidebarShopingCart.vue?vue&type=template&id=cafac72e&scoped=true"
import script from "./SidebarShopingCart.vue?vue&type=script&lang=js"
export * from "./SidebarShopingCart.vue?vue&type=script&lang=js"

import "./SidebarShopingCart.vue?vue&type=style&index=0&id=cafac72e&scoped=true&lang=css"
import "./SidebarShopingCart.vue?vue&type=style&index=1&id=cafac72e&lang=css"

import exportComponent from "C:\\laragon\\www\\bdroyelculture-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cafac72e"]])

export default __exports__